import { ReactNode } from 'react';
import { ModalHandler } from 'components/base/Modal';

export interface OptionType {
    label: ReactNode;
    value: string | number;
    options?: OptionType[];
}

export type OptionValueType = Array<OptionType['value']>;

interface BaseContentProps {
    value?: OptionValueType;
    options?: OptionType[];
}

export interface MobileContentProps extends BaseContentProps {
    onChange?: (value: OptionValueType, close?: boolean) => void;
    onDismiss?: ModalHandler['dismiss'];
}

export interface PanelContentProps extends BaseContentProps {
    /**
     * @param { boolean } close  选择完成后是否自动关闭面板
     */
    onChange?: (value: OptionValueType, close?: boolean) => void;
}
